import Styled from 'styled-components'

export const Title = Styled.p`
 margin-top: 20px;
`

export const Content = Styled.div`
display: flex;
flex-direction: column;
align-items: center;
gap: 2px;
padding: 8px 24px;
margin-bottom:20px;
`

export const NumPedido = Styled.span`
font-size: 15px;
`

export const ProductItem = Styled.p`
font-style: normal;
font-weight: 600;
font-size: 15px;
line-height: 145%;
letter-spacing: -0.01em;
`

export const SubProductItem = Styled.span`
`
export const ItemInformation = Styled.div`
padding: 20px;
`

export const Footer = Styled.div`
  position: relative;
  bottom: 0;
`

export const Line = Styled.div`
  margin: 10px;
  border-top: 1px solid rgba(154,158,163,0.2) !important;
`


export const Center = Styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`